"use strict";
/** @module AccountApi */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Mixin class for account/join site join request API calls.
 */
var JoinRequestMixin = /** @class */ (function () {
    function JoinRequestMixin() {
    }
    /**
     * Create join request
     * @TODO Figure out parameters and result, if any.
     * @param callback
     */
    JoinRequestMixin.prototype.createJoinRequest = function (agencyId, groupIds, message, callback) {
        var _this = this;
        var body = {
            agencyId: agencyId,
            groupIds: groupIds,
            message: message,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post('/join-requests', null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Cancel join request
     * @param joinRequestId
     * @param callback
     */
    JoinRequestMixin.prototype.cancelJoinRequest = function (joinRequestId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/join-requests/" + joinRequestId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    return JoinRequestMixin;
}());
exports.default = JoinRequestMixin;
//# sourceMappingURL=JoinRequestMixin.js.map